export default __webpack_public_path__ + "static/media/sandboxx-gift-card-horizontal-back.70140ef7.png";